import React, { useContext, useEffect, useState } from "react";
import { formatDate, numberWithCommas } from "../../../Utility";
import { Context } from "../../../Utility/ContextManager";
import { Row, Col } from "react-bootstrap";
import moment from "moment";

function LeaseSummary({ propertyDetail, leases, isMember, unfilteredLeases }) {
  const { dueData } = useContext(Context);
  const { avaAmount } = dueData;
  const [headers, setHeaders] = useState([]);
  const [rows, setRows] = useState([]);
  const [residentLease, setResidentLease] = useState(null);
  const checkIfExpired = (lease) => {
    console.log(lease);
    const currentDate = moment().format("YYYY-MM-DD");
    const leaseEndDate = moment.utc(lease?.lease_end).format("YYYY-MM-DD");
    if (leaseEndDate < currentDate) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (leases?.length > 0) {
      const headers = [
        { label: "Space ID", width: "150px" },
        ...leases.map((lease, index) => ({ label: lease.unit_name, index })),
      ];
      setHeaders(headers);
      const rows = [
        { label: "Address", values: leases.map((lease) => lease?.address1), width: "150px" },
        { label: "Lease Start Date", values: leases.map((lease) => formatDate(lease?.lease_start)) },
        { label: "Lease End Date", values: leases.map((lease) => formatDate(lease?.lease_end)) },
        { label: "Rent", values: leases.map((lease) => (lease?.rent ? `$${numberWithCommas(lease?.rent)}` : "")) },
        {
          label: "Security Deposit",
          values: leases.map((lease) =>
            lease?.security_deposit ? `$${numberWithCommas(lease?.security_deposit)}` : ""
          ),
        },
        {
          label: "",
          values: [],
        },

        // Add more rows for other lease details
      ];
      setRows(rows);
    }
  }, [leases, isMember]);
  const getRelevantLease = (leases) => {
    const currentDate = moment();
    let activeLease = null;
    let nextLease = null;
    let lastLease = null;

    leases?.forEach((lease) => {
      const leaseStartDate = moment(lease.lease_start);
      // Use a direct check on lease.lease_end to decide if moment conversion is necessary
      const leaseEndDate = lease.lease_end ? moment(lease.lease_end) : null;

      // Priority 1: Active lease
      if (
        leaseStartDate.isSameOrBefore(currentDate) &&
        (!lease.lease_end || leaseEndDate?.isSameOrAfter(currentDate))
      ) {
        activeLease = lease;
      }

      // Priority 2: Future lease
      if (
        leaseStartDate.isAfter(currentDate) &&
        (!nextLease || leaseStartDate.isBefore(moment(nextLease.lease_start)))
      ) {
        nextLease = lease;
      }

      // Priority 3: Most recent past lease
      if (
        leaseEndDate &&
        leaseEndDate.isBefore(currentDate) &&
        (!lastLease || leaseEndDate.isAfter(moment(lastLease.lease_end)))
      ) {
        lastLease = lease;
      }
    });

    // Determine which lease to return based on the conditions
    const relevantLease = activeLease || nextLease || lastLease;
    return relevantLease ? [relevantLease] : []; // Return in array format
  };
  

  useEffect(() => {
    if (unfilteredLeases?.length > 0) {
      const relevantLease = getRelevantLease(unfilteredLeases);
      setResidentLease(relevantLease?.length > 0 ? relevantLease[0] : null);
    }
  }, [unfilteredLeases]);
  return isMember ? (
    <div className="table-container" style={{ height: "100%" }}>
      <table className="table-responsive-2">
        <thead style={{ fontWeight: "0" }}>
          <tr>
            {headers.map((header, index) => (
              <th key={index} style={{ width: "450px" }}>
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex} className="table-row">
              <td>{row?.label}</td>
              {row?.values.map((value, colIndex) => (
                <td key={colIndex}>{value}</td>
              ))}
              <div style={{ marginTop: "50px" }} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div className="summary w-100" style={{ marginTop: "38px" }}>
      <p>
        {/*propertyDetail?.lease_type === "Month to Month" ? (
          <>
            {JSON.stringify(propertyDetail)}
            <strong style={{ float: "initial" }}>Month - to - Month</strong>
          </>
      ) :*/}
        <div>
          <Row>
            <Col lg={5}>{`Unit Name `}</Col>
            <Col lg={4}>{residentLease?.unit_name && residentLease?.unit_name}</Col>
          </Row>
          <Row className="mt-4">
            <Col lg={5}>{`Address`}</Col>
            <Col lg={7}>{residentLease?.address1 && residentLease?.address1}</Col>
          </Row>
          <Row className="mt-4">
            <Col lg={5}>{`Lease Start Date`}</Col>
            <Col lg={4}>{residentLease?.lease_start && formatDate(residentLease?.lease_start)}</Col>
          </Row>
          {residentLease?.lease_type === "Month to Month" ? (
            <Row className="mt-4">
              <Col lg={5}>{`Lease End Date`}</Col>
              <Col lg={4}>∞</Col>
            </Row>
          ) : (
            <Row className="mt-4">
              <Col lg={5}>{`Lease End Date`}</Col>
              <Col lg={4}>{residentLease?.lease_end && formatDate(residentLease?.lease_end)}</Col>
            </Row>
          )}
        </div>
      </p>
      <Row className="mt-4">
        <Col lg={5}> Rent </Col>
        <Col lg={4}>{residentLease?.rent && `$${numberWithCommas(residentLease?.rent)}`}</Col>
      </Row>
      <Row className="mt-4">
        <Col lg={5}>Security Deposit</Col>
        <Col lg={4}>{residentLease?.security_deposit && `$${numberWithCommas(residentLease?.security_deposit)}`}</Col>
      </Row>
      <Row className="mt-4">
        <Col lg={5}>Available Credit Balances</Col>
        <Col lg={7} className="d-flex">
          {residentLease?.available_balance && Number(residentLease?.available_balance) > 0
            ? `$${numberWithCommas(parseFloat(residentLease?.available_balance))}`
            : "$0"}
        </Col>
      </Row>
    </div>
  );
}

export default LeaseSummary;
